/**
 * 工程安装（engineeringInstallation）模块英文映射 · 第 2 组（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/engineeringInstallation/ 下
 * constructionManagement/modules/{enterConstruction,enterContract,examine,financialConfirmation,
 * flowable,leaderApproval,leaderDispatch,placeOn,surveyInformation}、constructionManagement/
 * {placeOn,surveyInformation,toDoList}.vue、engineeringInstallationDetail/ 全部页面及 home.vue
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并；
 * 通用词（确定/取消/关闭/提示/查询/重置/编辑/删除/新增/详情/更多/批量操作/操作/是/否/备注/请输入备注 等）复用 en-US.js，不重复收录
 */
export default {
  // ── 业务名词 ──
  '报装编号': 'Application No.',
  '报装类型': 'Application Type',
  '报装状态': 'Application Status',
  '报装申请时间': 'Application Time',
  '报装口径': 'Installation Caliber',
  '工程报装': 'Engineering Installation',
  '工程预算(元)': 'Project Budget (CNY)',
  '合同名称': 'Contract Name',
  '合同金额': 'Contract Amount',
  '合同金额(元)': 'Contract Amount (CNY)',
  '甲方': 'Party A',
  '乙方': 'Party B',
  '备注信息': 'Remarks',
  '备注说明': 'Remark Description',
  '附件': 'Attachment',
  '附件上传': 'Attachment Upload',
  '选择附件': 'Select Attachment',
  '合同附件': 'Contract Attachments',
  '费用附件': 'Fee Attachments',
  '施工附件': 'Construction Attachments',
  '验收附件': 'Acceptance Attachments',
  '施工备注': 'Construction Remarks',
  '施工环境': 'Construction Environment',
  '安全状况': 'Safety Condition',
  '正常': 'Normal',
  '恶劣': 'Harsh',
  '极度恶劣': 'Extremely Harsh',
  '勘察相约时间': 'Survey Appointment Time',
  '勘察实际时间': 'Actual Survey Time',
  '日供水量': 'Daily Water Supply',
  '日供水量(m³)': 'Daily Water Supply (m³)',
  '管线长度及规格(米)': 'Pipeline Length & Specification (m)',
  '是否排水': 'Drainage',
  '是否存在设计变更': 'Design Change or Not',
  '是否需要验收': 'Acceptance Required',
  '费用已收取': 'Fee Collected',
  '预存金额(元)': 'Prepaid Amount (CNY)',
  '项目说明': 'Project Description',
  '选择施工公司': 'Select Construction Company',
  '个人': 'Individual',
  '企业': 'Enterprise',
  '个人新装': 'New Individual Installation',
  '企业新装': 'New Enterprise Installation',
  '用水': 'Water Use',
  '换表': 'Meter Replacement',
  '故障报修': 'Fault Repair',
  '报停': 'Suspension',
  '复接': 'Reconnection',
  '小程序': 'Mini Program',
  '公众号': 'Official Account',
  '微信端游客': 'WeChat Guest',
  // ── 流程节点/状态 ──
  '新建工单': 'New Work Order',
  '现场勘察': 'On-site Survey',
  '设计方案': 'Design Proposal',
  '预算': 'Budget',
  '领导审批': 'Leader Approval',
  '财务缴费': 'Financial Payment',
  '现场施工': 'On-site Construction',
  '大厅复核': 'Hall Review',
  '归档': 'Archive',
  '已结束': 'Finished',
  '审批': 'Approval',
  '审核': 'Review',
  '通过': 'Approve',
  '驳回': 'Reject',
  '撤回': 'Withdraw',
  '转办': 'Transfer',
  '取消签收': 'Cancel Claim',
  '录入施工文件': 'Enter Construction Documents',
  '录入合同': 'Enter Contract',
  '录入信息': 'Enter Information',
  '财务确认': 'Financial Confirmation',
  '领导审批派单': 'Leader Approval & Dispatch',
  '工单编号': 'Work Order No.',
  '工单状态': 'Work Order Status',
  '工单紧急程度': 'Work Order Urgency',
  '当前任务': 'Current Task',
  '当前节点处理人': 'Current Node Handler',
  // ── 审批意见/表单校验 ──
  '审批意见': 'Approval Opinion',
  '审核意见': 'Review Opinion',
  '请选择审批意见': 'Please select approval opinion',
  '请选择下一节点操作人': 'Please select next node handler',
  '请上传施工附件': 'Please upload construction attachments',
  '请上传验收附件': 'Please upload acceptance attachments',
  '请选择是否存在设计变更': 'Please select whether there is a design change',
  '请选择是否需要验收': 'Select whether acceptance is required',
  '请选择是否已收取费用': 'Select whether the fee has been collected',
  '请选择施工公司': 'Select a construction company',
  '请选择安全状况': 'Select safety condition',
  '请选择勘察相约时间': 'Select survey appointment time',
  '请选择勘察实际时间': 'Select actual survey time',
  '请输入安全状况': 'Enter safety condition',
  '请输入施工备注': 'Please enter construction remarks',
  '请输入施工环境': 'Enter construction environment',
  '请输入日供水量': 'Enter daily water supply',
  '请输入管线长度及规格': 'Please enter pipeline length and specification',
  '请输入报装口径': 'Enter installation caliber',
  '请输入工程预算': 'Please enter project budget',
  '请输入预存金额': 'Enter prepaid amount',
  '请输入项目说明': 'Enter project description',
  '请输入合同名称': 'Please enter contract name',
  '请输入合同金额': 'Enter contract amount',
  '请输入甲方': 'Enter Party A',
  '请输入乙方': 'Enter Party B',
  '请输入备注信息': 'Please enter remark',
  '请输入报装编号': 'Please enter application No.',
  '请输入用户名称': 'Please enter customer name',
  '请输入工单编号': 'Please enter work order no.',
  '请选择人员': 'Please select personnel',
  '请选择创建人员': 'Please select creator',
  '请选择报装类型': 'Please select application type',
  '请选择报装申请时间': 'Select application time',
  '请选择工单紧急程度': 'Please select work order urgency',
  // ── 列表页 ──
  '导出': 'Export',
  '上传': 'Upload',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '名称': 'Name',
  '图片': 'Images',
  '来源': 'Source',
  '历时': 'Duration',
  '申请人': 'Applicant',
  '申请时间': 'Application Time',
  '更新时间': 'Updated At',
  '用户名称': 'Customer Name',
  '用户电话': 'Customer Phone',
  '收起': 'Collapse',
  '展开': 'Expand',
  '创建人员': 'Creator',
  '确定归档吗?': 'Are you sure to archive?',
  '确定关闭吗?': 'Are you sure to close?',
  '确定撤回吗?': 'Are you sure to withdraw?',
  // ── 操作提示 ──
  '操作成功': 'Operation successful',
  '操作失败': 'Operation failed',
  '处理成功': 'Processed Successfully',
  '开启成功': 'Started successfully',
  '开启失败': 'Failed to start',
  '接单成功': 'Order accepted successfully',
  '转办成功': 'Transferred successfully',
  '委派成功': 'Delegated successfully',
  '取消签收成功': 'Claim cancelled successfully',
  '存在必填内容未填！': 'Required fields are missing!',
  '选择转办人员': 'Select Transfer Personnel',
  '选择人员': 'Select Personnel',
  // ── 首页工作台 ──
  '我的待办': 'My To-do',
  '业务类别占比': 'Business Category Percentage',
  '业务数量': 'Business Volume',
  '业务数量趋势': 'Business Volume Trend',
  '近一周': 'Last 7 Days',
  '近一月': 'Last Month',
  '近一年': 'Last Year',
  '待办事项': 'To-do Items',
  '已办事项': 'Completed Items',
  '事项完成率': 'Item Completion Rate',
  '这是待办事项': 'This is the to-do count',
  '这是已办事项': 'This is the completed count',
  '这是事项完成率': 'This is the item completion rate',
  // ── 流程审批历史（复用工单模块译法）──
  '审批历史': 'Approval History',
  '流程图': 'Flow Chart',
  '流程审批进度历史': 'Approval Progress History',
  '流程实例ID不存在': 'Process instance ID does not exist',
  '待办中。。。': 'Pending...',
  '实际办理人：': 'Actual Handler: ',
  '接收时间：': 'Received At: ',
  '办结时间：': 'Completion Time: ',
  '通过：': 'Approved: ',
  '退回：': 'Returned: ',
  '驳回：': 'Rejected: ',
  '【会签中】': '[Countersigning]',
}
